//@flow
import React, { useEffect, useState, useRef } from 'react';
import ReactPlayer from 'react-player';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Image } from 'components/atoms/image';
import { StringUtil } from 'utils/StringUtil';
import { VisitArtistUrl } from 'components/atoms/visitArtistURL';
import artistWebsiteIcon from 'assets/images/Artist-Website_Artists-Arrow_Artists-Arrow.svg';
import playButton from 'assets/images/Play-Button-S.png';
import pauseButton from 'assets/images/pause.png';
import './style.scss';

type Props = {
  data: Object<dataProps>,
  type: string,
  openFor: string,
};

type dataProps = {
  id: number,
  page_title: string,
  cms_detail_page_contents: Array,
  media_path: string,
  thumbnail: string,
  mobile: string,
  web: string,
};

const OurHomesDescriptionOverlay = (props: Props) => {
  const { data } = props;
  const { website_url } = data;
  const [isVideoPlaying, setVideoPlaying] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [videoPlayedPercentage, setVideoPlayedPercentage] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isSeeking, setIsSeeking] = useState(false);
  const player = useRef(ReactPlayer);
  const CurrentVideoStatus = data => {
    if (!isSeeking) {
      const remainingTime = !data
        ? 0
        : parseFloat((duration - data.playedSeconds) / 60).toFixed(2);
      setVideoPlayedPercentage(data.played);
      setRemainingSeconds(remainingTime);
    }
  };
  const handleSeekMouseDown = e => {
    setIsSeeking(true);
  };
  const handleSeekChange = e => {
    setVideoPlayedPercentage(parseFloat(e.target.value));
  };
  const handleSeekMouseUp = e => {
    player.current.seekTo(parseFloat(e.target.value));
    setIsSeeking(false);
  };
  const handleOnready = e => {
    setVideoPlaying(true);
    setIsVideoLoaded(true);
  };
  useEffect(() => {
    const scrollTop = document.getElementsByClassName(
      'section-one-left-content'
    )[0];
    scrollTop.onscroll = function() {
      const bottom_content_element = scrollTop.children[2];
      bottom_content_element.children[0].classList.add('animated-scroll');
      bottom_content_element.children[1] &&
        bottom_content_element.children[1].classList.add('animated-scroll');
      bottom_content_element.children[2] &&
        bottom_content_element.children[2].classList.add(
          'animated-scroll-delay'
        );
      bottom_content_element.children[3] &&
        bottom_content_element.children[3].classList.add(
          'animated-scroll-delay'
        );
    };
  }, []);
  const openFor = props.openFor;
  let section_one = [];
  let section_two = [];
  let section_three = [];
  let section_four = [];
  const media_path = `${data.media_path}${data.web}`;
  const thumbnailUrl = `${data.media_path}${data.thumbnail}`;
  for (const extracted_data of data.cms_detail_page_contents) {
    if (extracted_data.section_name === 'section1') {
      section_one.push(extracted_data);
    } else if (extracted_data.section_name === 'section2') {
      section_two.push(extracted_data);
    } else if (extracted_data.section_name === 'section3') {
      section_three.push(extracted_data);
    } else if (extracted_data.section_name === 'section4') {
      section_four.push(extracted_data);
    }
  }

  const checkMediaType = (data, video_className, image_className) => {
    if (data.content_type === 'Video') {
      if (data && !data.video_thumbnail_url) {
        data.video_thumbnail_url = true;
      }
      return renderVideoContent(data, video_className);
    } else if (data.content_type === 'Image')
      return renderImageContent(data, image_className);
    else return null;
  };

  const renderVideoContent = (data, video_className) => {
    return (
      <>
        {data && (
          <>
            <div className="player-wrapper">
              <ReactPlayer
                ref={player}
                className="react-player"
                url={data.div_content}
                width="100%"
                height="100%"
                playing={isVideoPlaying}
                light={data.video_thumbnail_url}
                onProgress={CurrentVideoStatus}
                onReady={e => handleOnready(e)}
                loop={true}
                onDuration={e => setDuration(e)}
                config={{
                  vimeo: {
                    playerOptions: { playsinline: true },
                  },
                }}
              />
            </div>
            {isVideoLoaded && (
              <Row className="player-controls">
                <Col className="play-control" xs={{ span: 2 }} sm={{ span: 2 }}>
                  {isVideoPlaying && (
                    <img
                      className={'play-icon'}
                      src={pauseButton}
                      alt={'icon'}
                      style={{ width: '35px', height: '35px' }}
                      onClick={() => setVideoPlaying(!isVideoPlaying)}
                    />
                  )}
                  {!isVideoPlaying && (
                    <img
                      className={'play-icon'}
                      src={playButton}
                      alt={'icon'}
                      style={{ width: '35px', height: '35px' }}
                      onClick={() => setVideoPlaying(!isVideoPlaying)}
                    />
                  )}
                </Col>
                <Col className="seek-control" xs={{ span: 8 }} sm={{ span: 8 }}>
                  <input
                    type="range"
                    min={0}
                    max={0.999999}
                    step="any"
                    value={videoPlayedPercentage}
                    onMouseDown={handleSeekMouseDown}
                    onChange={handleSeekChange}
                    onMouseUp={handleSeekMouseUp}
                  />
                </Col>
                <Col className="time-control" xs={{ span: 2 }} sm={{ span: 2 }}>
                  <p>-{remainingSeconds}</p>
                </Col>
              </Row>
            )}
          </>
        )}
      </>
    );
  };

  const renderImageContent = (data, image_className) => {
    return (
      <Image
        className={image_className}
        src={`${media_path}/${data.div_content}`}
        alt={'overlay-image'}
        thumbNail={`${thumbnailUrl}/${data.div_content}`}
        isHoveredImagePresent={true}
      />
    );
  };

  return (
    <div className={'description-overlay-body'}>
      <div className={'overlay-inner-section'}>
        <Row className={'overlay-section-one'}>
          <Col md={{ span: 4 }} className={'section-one-left-content'}>
            <h2 className={'section-one-heading'}>
              {StringUtil.sliceHtml(section_one[0].div_content)}
            </h2>
            <h4 className={'section-one-tag-word'}>
              {StringUtil.sliceHtml(section_one[0].tag_word)}
            </h4>
            {website_url && (
              <VisitArtistUrl
                website_url={website_url}
                staticText={'ARTIST WEBSITE'}
                icon={artistWebsiteIcon}
              />
            )}
            <div className="section-one-bottom-content">
              <p>
                {StringUtil.formatDescription(section_one[1].div_content, 200)}
              </p>
              {section_one[2] &&
              section_one[2].div_content &&
              section_one[2].div_name === 'Left3' ? (
                <div className={`section-one-left-image ${openFor}`}>
                  {renderImageContent(section_one[2], 'feature-img')}
                </div>
              ) : null}
              <div className={'section-two-left-one'}>
                <div className={'vertical-bar'} />
                <h2 className={'section-two-heading'}>
                  {StringUtil.sliceHtml(section_two[0].div_content)}
                </h2>
              </div>
              {section_two[1] && (
                <p className={'section-two-left-paragraph'}>
                  {StringUtil.formatDescription(
                    section_two[1].div_content,
                    200
                  )}
                </p>
              )}
            </div>
          </Col>
          <Col md={{ span: 8 }}>
            <div className={'section-one-right-image'}>
              {section_one[2].div_name === 'Right1'
                ? renderImageContent(section_one[2], 'feature-img')
                : section_one[3].div_name === 'Right1'
                ? renderImageContent(section_one[3], 'feature-img')
                : null}
            </div>
          </Col>
        </Row>

        {(section_two[2] && Object.keys(section_two[2]).length > 0) ||
        (section_two[3] && Object.keys(section_two[3]).length > 0) ? (
          <div className={'section-two-container'}>
            {section_two[2] ? (
              <div className={'left-content'}>
                <span className={'media-tag-word'}>
                  {section_two[2].tag_word}
                </span>
                <div className={'media-container'}>
                  {checkMediaType(
                    section_two[2],
                    'feature-video',
                    'feature-img'
                  )}
                </div>
              </div>
            ) : null}
            {section_two[3] ? (
              <div className={'right-content'}>
                <h3>{section_two[3].tag_word}</h3>
                <p className={'section-two-left-paragraph'}>
                  {StringUtil.sliceHtml(section_two[3].div_content)}
                </p>
              </div>
            ) : null}
          </div>
        ) : null}

        {section_three.length > 0 ? (
          <div className={'section-three-container'}>
            <div className={'media-container'}>
              {section_three[0]
                ? checkMediaType(
                    section_three[0],
                    'feature-video',
                    'feature-img'
                  )
                : null}
            </div>
            {section_three[0] && section_three[0].tag_word ? (
              <span className={'media-tag-word'}>
                {section_three[0].tag_word}
              </span>
            ) : null}
          </div>
        ) : null}

        {section_four.length > 0 ? (
          <div className={'section-four-container'}>
            <div className={'left-content'}>
              <div className={'media-container'}>
                {section_four[0]
                  ? checkMediaType(
                      section_four[0],
                      'feature-video',
                      'feature-img'
                    )
                  : null}
              </div>
              {section_four[0] && section_four[0].tag_word ? (
                <span className={`${openFor} media-tag-word`}>
                  {section_four[0].tag_word}
                </span>
              ) : null}
            </div>
            <div className={'right-content'}>
              {section_four[1] ? (
                <div className={'right-one'}>
                  <h3>{section_four[1].tag_word}</h3>
                  <p className={'left-paragraph'}>
                    {StringUtil.formatDescription(
                      section_four[1].div_content,
                      35
                    )}
                  </p>
                </div>
              ) : null}
              {section_four[2] ? (
                <h2 className={'section-four-heading'}>
                  {StringUtil.sliceHtml(section_four[2].div_content)}
                </h2>
              ) : null}
              <div className={'right-two'}>
                <div className={'media-container'}>
                  {section_four[3]
                    ? checkMediaType(
                        section_four[3],
                        'feature-video',
                        'feature-img'
                      )
                    : null}
                </div>
                {section_four[3] && section_four[3].tag_word ? (
                  <span className={'media-tag-word'}>
                    {section_four[3].tag_word}
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default OurHomesDescriptionOverlay;
